export const getAheadTurns = (ticket, ticketOnAttention) => {
	if (ticket < ticketOnAttention) {
		let difference = ticket - ticketOnAttention;
		return -Math.abs(difference);
	} else {
		return ticket - ticketOnAttention;
	}
};
